<template>

  <div class="container-fluid"
       id="loginPage"
       style="opacity:1;transiton:all 1s linear"
       :class="{ fadeOutLogin: is_requesting }">

    <!-- <div class="pull-right">
    <button class="btn btn-outline-primary mt-3" @click="toggleLanguage">
      {{  $t('langName') }}
    </button>
  </div> -->

    <div class="authentication-main">
      <div class="row">
        <div class="p-0 col-md-4">
          <div class="auth-innerleft"
               style="background:url('/static/images/login_bg.png')">
            <div class="text-center">
              <router-link to="/"
                           :title="$t('backToLanding')">
                <img src="/static/planup.png?v=20260714"
                     alt="PlanUp">
              </router-link>
              <hr>
              PlanUp
              -
              ניהול אירועים חכם
            </div>
          </div>
        </div>
        <div class="p-0 col-md-8">
          <div class="auth-innerright">
            <div class="authentication-box">
              <h4>
                {{ $t('login') }}
              </h4>
              <h6 v-if="enteringMfaCode">
                <template v-if="selectedMfaMethod == 'email'">
                  שלחנו את הקוד לכתובת
                  <span v-if="resultFromFirstRequest && resultFromFirstRequest.data">{{
                    resultFromFirstRequest.data.hiddenMail }}</span>
                </template>
                <template v-else>
                  שלחנו את הקוד למספר
                  <div style="display:inline-block;direction:ltr">
                    {{ phoneNumber }}
                  </div>
                </template>
              </h6>
              <h6 v-else-if="showMfaMethodChooser">
                בחרו שיטת אימות
              </h6>
              <h6 v-else>
                {{ $t('enterUserAndPassword') }}
              </h6>
              <div v-show="!enteringMfaCode && !showMfaMethodChooser"
                   class="mt-4 p-4 mb-0 card">
                <form class="theme-form"
                      @submit.prevent="submitLogin">
                  <div class="form-group">
                    <label class="col-form-label pt-0">
                      דואר אלקטרוני
                    </label>
                    <input type="email"
                           @keypress.enter.stop="submitLogin"
                           class="form-control form-control-lg"
                           v-model="email">
                  </div>
                  <div class="form-group">
                    <label class="col-form-label pt-0">
                      {{ $t("password") }}
                    </label>
                    <div style="position: relative;">
                      <input :type="showPassword ? 'text' : 'password'"
                             @keypress.enter.stop="submitLogin"
                             class="form-control form-control-lg"
                             v-model="password"
                             style="padding-left: 40px;">
                      <button type="button"
                              @click="showPassword = !showPassword"
                              style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); border: none; background: none; cursor: pointer; padding: 5px;"
                              tabindex="-1">
                        <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" style="color: #666;"></i>
                      </button>
                    </div>
                  </div>
                  <div class="form-row mt-3 form-group">
                    <div class="col-md-3">
                      <button @click="submitLogin"
                              type="button"
                              class="btn btn-primary btn-block">
                        {{ $t('loginButton') }}
                      </button>
                    </div>
                    <div class="col-md-3">

                      <router-link to="/login/recover"
                        style="pointer-events: none;"
                               class="loginBtn"
                               tabindex="-1">
                        <button type="button" class="btn btn-outline-primary" tabindex="-1">
                          {{ $t("forgotPw") }}
                        </button>
                        </router-link>




                    </div>




                  </div>

                  <!-- no account yet: the signup wizard. Only on the password step (this card is hidden while a
                       code is asked for), and not on a new account's own first login (?loginToken=) -->
                  <div v-if="!$route.query.loginToken"
                       class="signupLine">
                    עדיין אין לכם חשבון?
                    <router-link to="/signup">30 ימי ניסיון חינם</router-link>
                  </div>

                  <hr v-if="false">

                  <div class="social mt-3"
                       v-if="false">
                    <div class="btn-showcase form-row">
                      <div class="col-sm-6 col-md-3">
                        <button @click="loginWithFacebook"
                                type="button"
                                class="btn btn-social-btn btn-fb">
                          <i class="fa-brands fa-facebook"></i>
                          &nbsp;

                          פייסבוק
                        </button>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <button type="button"
                                @click="loginWithGoogle"
                                class="btn btn-social-btn btn-google">


                          <i class="fa-brands fa-google"></i>
                          &nbsp;

                          גוגל

                        </button>

                        <div style="display:none !important">
                          <component is="script"
                                     src="https://accounts.google.com/gsi/client"
                                     async></component>
                          <div id="g_id_onload"
                               data-client_id="340965126822-psnjm1h1h26c5lgcreik4vjg39seepoo.apps.googleusercontent.com"
                               data-login_uri="https://planup.co.il/apiv2/tenancy/google"
                               data-auto_prompt="false">
                          </div>
                          <div class="g_id_signin"
                               data-type="standard"
                               data-size="large"
                               data-theme="outline"
                               data-text="sign_in_with"
                               data-shape="rectangular"
                               data-logo_alignment="left">
                          </div>
                        </div>




                      </div>
                      <div class="col-sm-6 col-md-3">
                        <button type="button"
                                class="btn btn-social-btn btn-github btn-block"
                                style="background-color: rgb(141, 110, 99); color: rgb(255, 255, 255);">
                          <i class="fa-regular fa-envelope"></i>
                          &nbsp;
                          SMS
                        </button>
                      </div>


                    </div>
                  </div>

                </form>
              </div>

              <!-- MFA method chooser (new) -->
              <div v-show="showMfaMethodChooser"
                   class="mt-4 p-4 mb-0 card">
                <h6>
                  לאן תרצו שנשלחו את קוד האימות?
                </h6>

                <form @submit.prevent="chooseMfaMethod()">
                  <div class="form-check mt-3">
                    <input class="form-check-input"
                           style="float:none;margin-left: 5px;position:relative;top:3px;"
                           type="radio"
                           id="mfaEmail"
                           value="email"
                           v-model="selectedMfaMethod">
                    <label class="form-check-label"
                           for="mfaEmail">
                      דואר אלקטרוני לכתובת:
                      <br>

                      <span v-if="resultFromFirstRequest && resultFromFirstRequest.data">{{
                        resultFromFirstRequest.data.hiddenMail }}</span>
                    </label>
                  </div>

                  <div class="form-check mt-3">
                    <input class="form-check-input"
                           style="float:none;margin-left: 5px;position:relative;top:3px;"
                           type="radio"
                           id="mfaSms"
                           value="sms"
                           v-model="selectedMfaMethod">
                    <label class="form-check-label"
                           for="mfaSms">
                      הודעת סמס למספר:
                      <br>
                      <div style="direction:ltr">
                        {{ phoneNumber }}
                      </div>

                    </label>
                  </div>
                  <br>
                  <div class="form-row mt-3">
                    <div class="col-md-3">
                      <button type="submit"
                              class="btn btn-primary btn-block"
                              :disabled="is_requesting">
                        שלח קוד
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <!-- existing MFA code form -->
              <div v-show="enteringMfaCode"
                   class="mt-4 p-4 mb-0 card">
                <form class="theme-form"
                      @submit.prevent="checkMfaCode(mfaCode)">
                  <div class="form-group">
                    <label class="col-form-label pt-0">
                      קוד אימות
                    </label>
                    <input v-model="mfaCode"
                           type="text"
                           inputmode="numeric"
                           autocomplete="one-time-code"
                           class="form-control form-control-lg"
                           @keypress.enter.stop="checkMfaCode(mfaCode)">
                  </div>
                  <div class="form-row mt-3 form-group">
                    <div class="col-md-3">
                      <button type="button"
                              class="btn btn-primary btn-block"
                              @click="checkMfaCode(mfaCode)">
                        המשך
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <!-- the way back to the landing page, whatever step the login is at -->
              <div class="mt-4 backToLanding">
                <router-link to="/">
                  <i class="fa-solid fa-arrow-right"></i>
                  {{ $t('backToLanding') }}
                </router-link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import Vue from 'vue';
import axiosV2, { apiPost } from '../core/http/axios_api_v2';
import { homeRouteFor } from '../core/acl/venue';

export default {
  name: "Login",

  data() {
    return {
      phoneNumber: 123,
      resultFromFirstRequest: null,
      resultFromSecondRequest: null,
      email: "",
      password: "",
      is_requesting: !!this.$router.currentRoute.query.loginToken,
      opacity: 0,
      enteringMfaCode: false,
      mfaCode: null,
      showMfaMethodChooser: false, // new flag
      selectedMfaMethod: 'email', // new: selected radio value
      showPassword: false,
      webOtpAbort: null
    };
  },
  components: {

  },
  computed: {
  },
  methods: {


    loginWithFacebook() {

      window.FB.login(function (response) {

        if (!response.status == 'connected' || !response.authResponse.accessToken) {
          alert('שגיאה');
          return;
        }

        axios.post('facebook/login', { token: response.authResponse.accessToken })

      }, { scope: 'email,pages_read_engagement' });

    },

    loginWithGoogle() {
      const googleLoginWrapper = document.createElement("div");
      googleLoginWrapper.style.display = "none";
      document.body.appendChild(googleLoginWrapper);

      window.google.accounts.id.renderButton(googleLoginWrapper, {
        type: "icon",
        width: "200",
      });

      googleLoginWrapper.querySelector("div[role=button]").click();
    },
    // toggleLanguage() {

    //   if (Vue.i18n.locale() == 'he') {

    //     document.body.classList.remove('rtl');
    //     Vue.i18n.set('en');
    //     this.$store.dispatch('saveLang', 'en');

    //   } else {

    //     document.body.classList.add('rtl');
    //     Vue.i18n.set('he');
    //     this.$store.dispatch('saveLang', 'he');

    //   }

    // },

    // WebOTP (Chrome/Android): resolves when the MFA SMS arrives, since the SMS
    // ends with "@planup.co.il #<code>". iOS ignores this and uses the
    // autocomplete="one-time-code" keyboard suggestion instead.
    startWebOtpListener() {
      if (!('OTPCredential' in window)) return;
      this.stopWebOtpListener();
      this.webOtpAbort = new AbortController();
      var self = this;
      navigator.credentials.get({
        otp: { transport: ['sms'] },
        signal: this.webOtpAbort.signal
      }).then(function (otp) {
        if (otp && otp.code) {
          self.mfaCode = otp.code;
          self.checkMfaCode(otp.code);
        }
      }).catch(function () {
        // aborted, unsupported or user dismissed the prompt — code is typed manually
      });
    },

    stopWebOtpListener() {
      if (this.webOtpAbort) {
        this.webOtpAbort.abort();
        this.webOtpAbort = null;
      }
    },

    async chooseMfaMethod(method) {

      // use passed method or selected radio value
      const chosen = method || this.selectedMfaMethod;

      // arm before the send request so the listener is live when the SMS lands
      if (chosen == 'sms') this.startWebOtpListener();

      this.$data.is_requesting = true;

      let headers = { 'x-tenant-id': 'default' }

      axiosV2.post('tenancy/auth/chooseMfaMethod', {
        method: chosen,
        secret: this.resultFromFirstRequest.data.secret
      }, { headers })

        .then(result => {
          this.resultFromSecondRequest = result;

          // hide chooser and show code input
          this.showMfaMethodChooser = false;
          this.enteringMfaCode = true;

        })

        .catch(err => {
          this.AlertError('שגיאה בשליחת קוד אימות');
        })

        .finally(() => {
          this.$data.is_requesting = false;
        })

    },

    async checkMfaCode(code) {


      this.$data.is_requesting = true;


      let headers = { 'x-tenant-id': 'default', 'Authorization': `Bearer ${this.$store.state.accessToken}` }




      let secret = this.resultFromFirstRequest.data.secret;


      axiosV2.post('tenancy/auth/checkCode', {
        code,
        secret
      }, { headers })


        .then(result => {

          this.$store.commit('setAccessToken', result.data.access_token)
          this.$store.commit('setTenant', result.data.tenant)
          this.$store.state.user = result.data.user;
          this.$router.push(homeRouteFor(result.data.user));

        })

        .catch(err => {

          this.AlertError('קוד לא תקין')

        })

        .finally(() => {
          this.$data.is_requesting = false;
        })


    },



    async submitLogin(e) {


      this.$data.is_requesting = true;

      let headers = { 'x-tenant-id': 'default' }


      axiosV2.post('tenancy/auth/login', {
        username: this.email,
        password: this.password
      }, { headers })

        .then(result => {




            
          if (result.data.user) {
            this.$store.commit('setAccessToken', result.data.access_token)
            this.$store.commit('setTenant', result.data.tenant)
            this.$store.state.user = result.data.user;
            this.$router.push(homeRouteFor(result.data.user));
            return;
          }








          // show method chooser (do not go straight to code input)
          this.showMfaMethodChooser = true;
          this.resultFromFirstRequest = result;
          // backend may return masked phone or hiddenPhone/hiddenMail
          this.phoneNumber = result.data.phone || result.data.hiddenPhone || this.phoneNumber;
        })

        .catch(err => {

          //a frozen account (root admin) answers 403 with the reason - show that, not "wrong password"
          var serverMessage = err && err.data && err.data.message;

          if (err && err.status == 403 && serverMessage) {
            this.AlertError(serverMessage);
            return;
          }

          this.AlertError(this.$t("invalidLogin"))
        })

        .finally(() => {
          this.$data.is_requesting = false;
        })

    },


    async socketConnect(userId, tenantId) {

      // console.log('Connecting socket')

      // const socketUser = tenantId ? `${tenantId}_${userId}` : `${userId}`

      // const socketUser = tenantId;
      // await this.$socket.connect()
      // this.$socket.emit('setUser', socketUser)
      // this.$socket.emit('hello',{test:'test'})




      // console.log('setuser');


    }
  },



  beforeDestroy() {
    this.stopWebOtpListener();
  },

  mounted() {

    if (typeof this.$router.currentRoute.query.userNotFound != 'undefined') {

      this.$notify({
        type: 'error',
        title: 'שגיאה',
        text: 'המשתמש לא נמצא',
        duration: 2500
      })
    }


    //NOTE: the ?email=&autoLogin=1 hand-off (the root admin re-submitting this form with a dummy
    //password, which only the office IPs were allowed to skip) is gone: the root admin enters an
    //account through core/auth/login-as-tenant, on a token the server mints for that account.

    //Google sign-in still needs the second step (the code by SMS / mail): the server sends the
    //challenge back on the URL (tenancy/google) - the same chooser the password login shows
    var query = this.$router.currentRoute.query;
    if (query.mfa) {
      this.resultFromFirstRequest = { data: { secret: query.mfa, hiddenMail: query.hm || '', hiddenPhone: query.hp || '' } };
      this.phoneNumber = query.hp || this.phoneNumber;
      this.showMfaMethodChooser = true;
      this.$router.replace({ path: '/login' }).catch(function () { });
    }

    if (this.$router.currentRoute.query.loginToken) {

      axios.post(`tenancy/loginWithLoginToken`, { singleUseToken: this.$router.currentRoute.query.loginToken }).then(response => {

        console.log(response.data);

        this.$store.commit('setAccessToken', response.data.token)
        this.$store.commit('setTenant', response.data.tenant)
        this.$router.push(homeRouteFor(this.$store.state.user));
        this.socketConnect(1, response.data.tenant); //need to test this
        console.log('test socket connection')
      })


    }




  }
};
</script>

<style scoped>
.fadeOutLogin {
  opacity: 0 !important
}

.backToLanding a {
  color: #7a5fb5;
  font-weight: 500;
}

.backToLanding a:hover,
.backToLanding a:focus {
  color: #5d4690;
  text-decoration: underline;
}

.backToLanding i {
  font-size: 13px;
  margin-left: 4px;
}

.signupLine {
  padding-top: 14px;
  border-top: 1px solid #ece8f5;
  color: #6b7088;
  font-size: 14px;
}

.signupLine a {
  color: #7a5fb5;
  font-weight: 600;
}

.signupLine a:hover,
.signupLine a:focus {
  color: #5d4690;
  text-decoration: underline;
}
</style>